import script from "./ReturnSlipDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReturnSlipDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ReturnSlipDetail.vue?vue&type=style&index=0&id=d3f3ae48&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3f3ae48"]])

export default __exports__